import { useEffect, useState } from 'react';

/** Desktop sheet radius (matches notifications + active-users CSS). */
export const SHEET_RADIUS_DESKTOP = 14;
/** Mobile sheet radius (≤576px breakpoint). */
export const SHEET_RADIUS_MOBILE = 10;
const MOBILE_MQ = '(max-width: 576px)';

/**
 * Returns the sheet border-radius that matches CSS `--sheet-radius`
 * so LiquidGlass WebGL corners stay aligned with the outer shell.
 */
export function useSheetRadius(): number {
  const [radius, setRadius] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia(MOBILE_MQ).matches
      ? SHEET_RADIUS_MOBILE
      : SHEET_RADIUS_DESKTOP,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_MQ);
    const sync = () =>
      setRadius(mq.matches ? SHEET_RADIUS_MOBILE : SHEET_RADIUS_DESKTOP);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return radius;
}
